import styled, { keyframes } from "styled-components";

export const slideInFromRight = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const slideOutToRight = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const ToastContainer = styled.div`
  .billingToast {
    display: flex;
    align-items: center;
    gap: 5px;
    position: absolute;
    top: -5px;
    right: 35px;
    height: 20px;
    background-color: var(--menu-color);
    z-index: -1;
    border-radius: 9px;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
    padding: 10px 13px;
    font-size: 12px;
    font-family: "IBM Plex Mono", monospace;
    font-weight: 400;
    line-height: 124.2%;
    color: var(--grey-0);
    animation: ${slideInFromRight} 1s ease forwards, ${fadeIn} 1s ease forwards, ${slideOutToRight} 1s ease 2s forwards, ${fadeOut} 1s ease 2s forwards;

    svg {
      width: 20px;

      path {
        fill: var(--grey-2);
      }
    }
  }
`;
